import type { BlobDataRequest, BlobDataResponse } from '@/models/blob'
import type { BlobResponseDTO } from '@/models/dto/blob-dto'
import { mapToBlobRequestDTO, mapToBlobResponse } from '@/models/mappers/blob-mapper'
import type { FetchOptionsType } from './api'
import { deleteJsonRequest, postFormDataRequest, putFormDataRequest } from './make-request'

type BlobCrudType = (fetchOptions?: FetchOptionsType) => {
    post: (file: BlobDataRequest) => Promise<BlobDataResponse>
    put: (path: string, file: BlobDataRequest) => Promise<BlobDataResponse>
    delete: (body: string) => Promise<void>
}

const BLOB_URL = typeof window === 'undefined' ? `${process.env.API_URL}/api/v1/Blob` : `${location.origin}/api/v1/Blob`
const BLOB_TAG = 'blob'

const blobCRUD: BlobCrudType = (fetchOptions) => ({
    post: async (file) => {
        const blobRequestDTO = mapToBlobRequestDTO(file)
        const url = new URL(BLOB_URL)
        const body = new FormData()
        body.append('Blob', blobRequestDTO.Blob)
        body.append('Folder', blobRequestDTO.Folder)
        const blobResponseDTO = await postFormDataRequest<BlobResponseDTO>({
            url,
            body,
            next: { tags: [BLOB_TAG] },
            ...fetchOptions,
        })
        const blobResponse = mapToBlobResponse(blobResponseDTO)
        return blobResponse
    },
    put: async (path, file) => {
        const blobRequestDTO = mapToBlobRequestDTO(file)
        const url = new URL(BLOB_URL)
        url.searchParams.append('oldBlobPath', path)
        const body = new FormData()
        body.append('Blob', blobRequestDTO.Blob)
        body.append('Folder', blobRequestDTO.Folder)
        const blobResponseDTO = await putFormDataRequest<BlobResponseDTO>({
            url,
            body,
            next: { tags: [BLOB_TAG] },
            ...fetchOptions,
        })
        const blobResponse = mapToBlobResponse(blobResponseDTO)
        return blobResponse
    },
    delete: async (body) => {
        const url = new URL(BLOB_URL)
        await deleteJsonRequest({ url, body, ...fetchOptions })
    },
})

export { BLOB_TAG, blobCRUD, type BlobCrudType }
